import request from "../utils/request";

export function getQaSNotifications(company) {
  let query = "";
  if (company !== undefined) {
    query += `?company=${company}`;
  }
  return request({
    url: `/qas/notifications${query}`,
    method: "get",
  });
}

export function getQaSList(pagination) {
  return request({
    url: `/qas`,
    method: "get",
    params: pagination,
  });
}

export function getQaS(id) {
  return request({
    url: `/qas/${id}`,
    method: "get",
  });
}

export function setQaSResponse(id, response, classification) {
  return request({
    url: `/qas/${id}/response`,
    method: "post",
    data: {
      response,
      classification,
    },
  });
}
